$(window).on('load', function() {
    var dialogShowEachSession = $('#tms-dialog').data('dialog-session');
    var dialogShown = localStorage.getItem('tmsDialogShown');
    if (typeof dialogShowEachSession !== 'undefined')
        dialogShown = sessionStorage.getItem('tmsDialogShown');

    var dialogContentHash = $('#tms-dialog').data('dialog-contenthash');
    if (dialogShown !== dialogContentHash) {
        $('#tms-dialog').modal('show');
        if (typeof dialogShowEachSession !== 'undefined')
            sessionStorage.setItem('tmsDialogShown', dialogContentHash);
        else
            localStorage.setItem('tmsDialogShown', dialogContentHash);
    }
});
